import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MenuPage from "../pages/menu/page";
import TrackingPage from "../pages/tracking/page";
import ReviewsPage from "../pages/reviews/page";
import LoginPage from "../pages/auth/login/page";
import RegisterPage from "../pages/auth/register/page";
import AccountPage from "../pages/account/page";
import BeveragePage from "../pages/beverage/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminOrdersPage from "../pages/admin/orders/page";
import AdminRoute from "../components/feature/AdminRoute";
import AdminMessagesPage from "../pages/admin/messages/page";
import AdminPaymentsPage from "../pages/admin/payments/page";
import AdminRidersPage from "../pages/admin/riders/page";
import AdminReviewsPage from "../pages/admin/reviews/page";
import AdminCustomersPage from "../pages/admin/customers/page";
import OrderTrackingPage from "../pages/order/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/menu", element: <MenuPage /> },
  { path: "/beverage/:id", element: <BeveragePage /> },
  { path: "/tracking", element: <TrackingPage /> },
  { path: "/order/:id", element: <OrderTrackingPage /> },
  { path: "/reviews", element: <ReviewsPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/account", element: <AccountPage /> },
  { path: "/admin/login", element: <AdminLoginPage /> },
  {
    path: "/admin/orders",
    element: (
      <AdminRoute>
        <AdminOrdersPage />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/messages",
    element: (
      <AdminRoute>
        <AdminMessagesPage />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/payments",
    element: (
      <AdminRoute>
        <AdminPaymentsPage />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/riders",
    element: (
      <AdminRoute>
        <AdminRidersPage />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/reviews",
    element: (
      <AdminRoute>
        <AdminReviewsPage />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/customers",
    element: (
      <AdminRoute>
        <AdminCustomersPage />
      </AdminRoute>
    ),
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
